import { useNavigate, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useAuth } from "@/lib/auth";
import { LegalConsent } from "@/components/LegalLinks";

export default function Auth() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading && user) navigate("/dashboard", { replace: true });
  }, [user, loading, navigate]);

  const handleGoogleLogin = () => {
    window.location.href = `${process.env.REACT_APP_BACKEND_URL}/api/auth/google`;
  };

  return (
    <div className="min-h-screen bg-background flex flex-col" data-testid="auth-page">
      <nav className="px-6 h-16 flex items-center">
        <Link to="/" className="flex items-center">
          <img src="/logo-lockup.svg" alt="CartControl" className="h-8 w-auto" />
        </Link>
      </nav>

      <div className="flex-1 flex items-center justify-center px-6 pb-16">
        <Card className="w-full max-w-md border-border shadow-sm" data-testid="auth-card">
          <CardHeader className="text-center pb-2">
            <CardTitle className="text-2xl font-semibold text-gray-900 font-display">
              Welcome to CartControl
            </CardTitle>
            <CardDescription className="text-gray-500 text-sm">
              Sign in to start your 30-day free trial. No credit card required.
            </CardDescription>
          </CardHeader>
          <CardContent className="pt-6">
            <Button
              type="button"
              variant="outline"
              className="w-full h-12 border-border text-gray-700 hover:bg-muted font-medium text-sm"
              onClick={handleGoogleLogin}
              data-testid="google-login-btn"
            >
              <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/></svg>
              Continue with Google
            </Button>
            <div className="mt-6 text-center">
              <LegalConsent prefix="By signing in, you agree to our" />
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
